<template>
  <div class="cotent" v-if="$_isMobile()">
    <template v-if="item.path!='product'">
      <b-button v-if="item.active" variant="primary" block  style="width: 100%;">{{$t(item.text)}}</b-button>
      <b-button v-else variant="light" block  @click="handlePage(item.path)" style="width: 100%;">{{$t(item.text)}}</b-button>
    </template>
    <template v-else>
      <b-button v-if="item.active" variant="primary" block  style="width: 100%;" @click="handleOpen()">{{$t(item.text)}}</b-button>
      <b-button v-else variant="light" block  @click="handleOpen()" style="width: 100%;">{{$t(item.text)}}</b-button>
      <ul class="nav-ul" v-show=" isOpenNav"  >
        <li v-for="(item, index) in cardData" :key="index">
          <router-link :to="'/product?type='+item.id" >
            <span>{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </template>
  </div>
  <div class="cotent" @mouseenter="handleEnter"  @mouseleave="handleLeave"  v-else >
    <b-button v-if="item.active" variant="primary" pill    @click="handlePage(item.path)">{{$t(item.text)}}</b-button>
    <b-button v-else variant="light" pill @click="handlePage(item.path)">{{$t(item.text)}}</b-button>
    <template v-if="item.path=='product'">
      <ul class="nav-ul" v-show=" isOpenNav"   @mouseenter="handleEnters"  @mouseleave="handleLeaves" >
        <li v-for="(item, index) in cardData" :key="index">
          <router-link :to="'/product?type='+item.id" >
            <span>{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </template>
  </div>
  
</template>

<script>
import Resize from "@/mixin/Resize";

export default {
  mixins: [Resize],
  data() {
    return {
      isOpenNav: false,
      isOpenNav: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    cardData: {
      type: Array||Object,
      default:[]
    }
  },  

  watch: {
    $route(route) {
      // console.log(this.isOpenNav)
      this.isOpenNav =false
    }
  },
  methods: {
    handlePage(path) {
      let routePath = this.$route.path.replace("/", "");
      if(path != 'product'){
        //  this.isOpenNav = false
         console.log(this.isOpenNav)
        if(routePath != path){
         
          this.$router.push(path)
        }
      }else{
        // this.isOpenNav = !this.isOpenNav
      }
    },
    handleEnter(e){
        // console.log(e);
        this.isOpenNav = true
        // this.message = '修改值';
    },
    handleOpen(){
      this.isOpenNav = !this.isOpenNav
    },  
    handleEnters(){
      this.isOpenNavs = false
    },
    handleLeaves(){
      this.isOpenNavs = true
      this.isOpenNav = false
    },
    handleLeave(e){
      let that = this
      setTimeout(function(){
        if(that.isOpenNavs){
          that.isOpenNav = false
        }
      },200)
      // console.log(e);
      // this.message = '默认值111';
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.cotent {
  display: inline-block;
  position: relative;
  // width: 100%;
}
@import '@/style/var.scss';

.btn-primary {
  color: $white;
}
.btn-light:hover{
  background: $primary;
  color: $white;
}
.btn-light {
  background-color:#fff;
  border-color: #fff;
}
.btn-primary,
.btn-light {
  // margin-right: 10px;
  margin:0 20px;
}
.nav-ul{
  position: absolute;
  top: 50px;
  background: #fff;
  left: 4px;
  border: 2px solid #798dc8;
  // width: 160px;
  padding: 0;
  z-index: 999;
  li {
    text-decoration: none;
    list-style: none;
    display: inline-block;
    /* margin: 10px; */
    width: 180px;
    margin: 8px 16px;
    padding: 10px 0px;
  // padding: 10px 30px;

    span{
      color: #000;
      margin-left: 4px;
    }
  }
  li:hover {
    background:#798dc8 ;
    span{
      color: #fff;
    }
  }
}
@media only screen and (max-width: 667px) {
.btn-primary,.btn-light {
    // margin-right: 10px;
    margin:0 0px;
  }
  .cotent{
    width:100%;
  }
}

</style>
